import Icon from "../../../../Icon"

import styles from "./IconCell.module.less"

/**
 * The single graphic that means "not filled in" everywhere on the page.
 *
 * Deliberately not derived from the value — no letter, no monogram, no generated glyph, since a
 * generated letter would read as a real brand mark. The same component backs the Unmapped summary
 * block, so the block and the table cannot drift into two different marks for the same idea.
 */
const FallbackMarker = () => <Icon type="alert_triangle_error" className={styles.marker} />

export default FallbackMarker
